<template>
  <nav class="navigation-top">
    <div class="container">
      <div class="nav-wrapper">
        <Widget position="MainMenu"/>
        <router-link v-if="!isLoggedIn" :to="$i18nRoute({ name: 'login' })" class="login-btn-fixed">
          <img src="@/assets/log-in.png" :alt="$t('Войти')">
        </router-link>
      </div>
    </div>
  </nav>
</template>

<script>
import Widget from '@/components/app/Widget'

export default {
  components: {
    Widget
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters.isLoggedIn
    }
  },
}
</script>
